import { render, staticRenderFns } from "./Dialog_StoreSecondHeadTeacher.vue?vue&type=template&id=d2588200&scoped=true&"
import script from "./Dialog_StoreSecondHeadTeacher.vue?vue&type=script&lang=js&"
export * from "./Dialog_StoreSecondHeadTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2588200",
  null
  
)

export default component.exports